module.exports = __webpack_public_path__ + "img/216.f0e82e9b.png";